import { NgModule} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSliderModule } from '@angular/material/slider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { GridModule, PageService, SortService, FilterService, GroupService, ExcelExportService, ToolbarService, EditService, AggregateService, ResizeService, DetailRowService } from '@syncfusion/ej2-angular-grids';
import { UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { TabModule } from '@syncfusion/ej2-angular-navigations';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { AnnotationsService, CircularGaugeModule } from '@syncfusion/ej2-angular-circulargauge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from '../../../../src/app/shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AutoCompleteModule, ComboBoxModule } from '@syncfusion/ej2-angular-dropdowns';
import { RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { AccumulationAnnotationService, AccumulationChartModule, AccumulationDataLabelService, AccumulationLegendService, AccumulationTooltipService, PieSeriesService } from '@syncfusion/ej2-angular-charts';

import { DefaultComponent} from './default.component';
import { SubmenuItemComponent } from '../../shared/components/sidebar/submenu-item.component';
import { MenuItemComponent } from '../../shared/components/sidebar/menu-item.component';
import { MenuLinkItemComponent } from '../../shared/components/sidebar/menu-link-item.component';
import { MatChipsModule } from '@angular/material/chips';
import { AgmCoreModule } from '@agm/core'

import { AsistenciasListaComponent } from '../../pages/asistencias/asistenciasLista.component';
import { UsuarioEditComponent } from '../../pages/usuarios/usuarioEdit.component';
import { UsuarioSelfEditComponent } from '../../pages/usuarios/usuarioSelfEdit.component';
import { UsuarioListaComponent } from '../../pages/usuarios/usuarioLista.component';
import { RolListaComponent } from '../../pages/roles/rolLista.component';
import { RolEditComponent } from '../../pages/roles/rolEdit.component';
import { EstadoListaComponent } from '../../pages/estados/estadoLista.component';
import { EstadoEditComponent } from '../../pages/estados/estadoEdit.component';
import { MensajeUsuarioListaComponent } from '../../pages/mensaje-usuario/mensajeUsuarioLista.component';
import { MensajeUsuarioEditComponent } from '../../pages/mensaje-usuario/mensajeUsuarioEdit.component';
import { MensajeUsuarioViewComponent } from '../../pages/mensaje-usuario/mensajeUsuarioView.component';
import { ParametroSistemaListaComponent } from '../../pages/parametro-sistema/parametroSistemaLista.component';
import { ParametroSistemaEditComponent } from '../../pages/parametro-sistema/parametroSistemaEdit.component';
import { MenuListaComponent } from '../../pages/menues/menuLista.component';
import { MenuEditComponent } from '../../pages/menues/menuEdit.component';
import { MensajeUsuarioTipoListaComponent } from '../../pages/mensaje-usuario-tipo/mensajeUsuarioTipoLista.component';
import { MensajeUsuarioTipoEditComponent } from '../../pages/mensaje-usuario-tipo/mensajeUsuarioTipoEdit.component';
import { MensajeUsuarioOpcionEnvioListaComponent } from '../../pages/mensaje-usuario-opcion-envio/mensajeUsuarioOpcionEnvioLista.component';
import { MensajeUsuarioOpcionEnvioEditComponent } from '../../pages/mensaje-usuario-opcion-envio/mensajeUsuarioOpcionEnvioEdit.component';
import { MailConfiguracionListaComponent } from '../../pages/mail-configuracion/mailConfiguracionLista.component';
import { MailConfiguracionEditComponent } from '../../pages/mail-configuracion/mailConfiguracionEdit.component';
import { TenantListaComponent } from '../../pages/tenants/tenantLista.component';
import { TenantEditComponent } from '../../pages/tenants/tenantEdit.component';
import { RolTipoListaComponent } from '../../pages/rol-tipo/rolTipoLista.component';
import { RolTipoEditComponent } from '../../pages/rol-tipo/rolTipoEdit.component';
import { FaqListaComponent } from '../../pages/faq/faqLista.component';
import { FaqEditComponent } from '../../pages/faq/faqEdit.component';
import { FaqViewComponent } from '../../pages/faq/faqView.component';
import { HomeComponent } from '../../pages/home/home.component';
import { PersonaListaComponent } from '../../../../src/app/pages/usuarios/personaLista.component';
import { PersonaEditComponent } from '../../../../src/app/pages/usuarios/personaEdit.component';

import { CategoriaSuterhListaComponent } from '../../pages/categoria-suterh/categoriaSuterhLista.component';
import { CategoriaSuterhEditComponent } from '../../pages/categoria-suterh/categoriaSuterhEdit.component';
import { MonedaListaComponent } from '../../pages/moneda/monedaLista.component';
import { MonedaEditComponent } from '../../pages/moneda/monedaEdit.component';
import { PaisListaComponent } from '../../pages/pais/paisLista.component';
import { PaisEditComponent } from '../../pages/pais/paisEdit.component';
import { TipoDocumentoListaComponent } from '../../pages/tipo-documento/tipoDocumentoLista.component';
import { TipoDocumentoEditComponent } from '../../pages/tipo-documento/tipoDocumentoEdit.component';
import { TipoGastoListaComponent } from '../../pages/tipo-gasto/tipoGastoLista.component';
import { TipoGastoEditComponent } from '../../pages/tipo-gasto/tipoGastoEdit.component';
import { TipoResponsableIvaListaComponent } from '../../pages/tipo-responsable-iva/tipoResponsableIvaLista.component';
import { TipoResponsableIvaEditComponent } from '../../pages/tipo-responsable-iva/tipoResponsableIvaEdit.component';
import { TipoUnidadListaComponent } from '../../pages/tipo-unidad/tipoUnidadLista.component';
import { TipoUnidadEditComponent } from '../../pages/tipo-unidad/tipoUnidadEdit.component';
import { TipoComunidadListaComponent } from '../../pages/tipo-comunidad/tipoComunidadLista.component';
import { TipoComunidadEditComponent } from '../../pages/tipo-comunidad/tipoComunidadEdit.component';
import { ProvinciaListaComponent } from '../../pages/provincia/provinciaLista.component';
import { ProvinciaEditComponent } from '../../pages/provincia/provinciaEdit.component';
import { UnidadFuncionalListaComponent } from '../../pages/unidad-funcional/unidadFuncionalLista.component';
import { UnidadFuncionalEditComponent } from '../../pages/unidad-funcional/unidadFuncionalEdit.component';
import { UnidadFuncionalPersonaComponent } from '../../../../src/app/pages/unidad-funcional/unidadFuncionalPersona.component';
import { ComunidadListaComponent } from '../../../../src/app/pages/comunidad/comunidadLista.component';
import { ComunidadEditComponent } from '../../../../src/app/pages/comunidad/comunidadEdit.component';
import { ComunidadPublicacionListaComponent } from '../../../../src/app/pages/publicaciones/comunidadPublicacionLista.component';
import { ComunidadPublicacionEditComponent } from '../../../../src/app/pages/publicaciones/comunidadPublicacionEdit.component';
import { ComunidadPublicacionViewComponent } from '../../../../src/app/pages/publicaciones/comunidadPublicacionView.component';
import { UfTipoRelacionListaComponent } from '../../../../src/app/pages/uf-tipo-relacion/ufTipoRelacionLista.component';
import { UfTipoRelacionEditComponent } from '../../../../src/app/pages/uf-tipo-relacion/ufTipoRelacionEdit.component';
import { ConsorcioListaComponent } from '../../../../src/app/pages/consorcio/consorcioLista.component';
import { ConsorcioEditComponent } from '../../../../src/app/pages/consorcio/consorcioEdit.component';
import { CategoriaGastoListaComponent } from '../../../../src/app/pages/categoria-gasto/categoriaGastoLista.component';
import { CategoriaGastoEditComponent } from '../../../../src/app/pages/categoria-gasto/categoriaGastoEdit.component';
import { ServicioGastoListaComponent } from '../../../../src/app/pages/servicio-gasto/servicioGastoLista.component';
import { ServicioGastoEditComponent } from '../../../../src/app/pages/servicio-gasto/servicioGastoEdit.component';
import { ExpensaConfiguracionComponent } from '../../../../src/app/pages/expensa/expensaConfiguracion.component';
import { ExpensaLiquidacionComponent } from '../../../../src/app/pages/expensa/expensaLiquidacion.component';
import { ExpensaListaComponent } from '../../../../src/app/pages/expensa/expensaLista.component';
import { ExpensaEditComponent } from '../../../../src/app/pages/expensa/expensaEdit.component';
import { GastoListaComponent } from '../../../../src/app/pages/gasto/gastoLista.component';
import { MiGastoListaComponent } from '../../../../src/app/pages/gasto/miGastoLista.component';
import { GastoEditComponent } from '../../../../src/app/pages/gasto/gastoEdit.component';
import { GastoRecurrenteComponent } from '../../pages/gasto/gastoRecurrente.component';
import { GastoDesdeDocumentoComponent } from '../../pages/gasto/gastoDesdeDocumento.component';
import { ServicioGrupoListaComponent } from '../../../../src/app/pages/servicio-grupo/servicioGrupoLista.component';
import { ServicioGrupoEditComponent } from '../../../../src/app/pages/servicio-grupo/servicioGrupoEdit.component';
import { ContratoListaComponent } from '../../../../src/app/pages/contrato/contratoLista.component';
import { ContratoEditComponent } from '../../../../src/app/pages/contrato/contratoEdit.component';
import { IncidenciaUsuarioBackofficeListaComponent } from '../../pages/incidencia-usuario/backoffice/incidenciaUsuarioBackofficeLista.component';
import { IncidenciaUsuarioBackofficeEditComponent } from '../../pages/incidencia-usuario/backoffice/incidenciaUsuarioBackofficeEdit.component';
import { IncidenciaUsuarioListaComponent } from '../../pages/incidencia-usuario/user/incidenciaUsuarioLista.component';
import { IncidenciaUsuarioEditComponent } from '../../pages/incidencia-usuario/user/incidenciaUsuarioEdit.component';
import { IncidenciaUsuarioCategoriaListaComponent } from '../../../../src/app/pages/incidencia-usuario-categoria/incidenciaUsuarioCategoriaLista.component';
import { IncidenciaUsuarioCategoriaEditComponent } from '../../../../src/app/pages/incidencia-usuario-categoria/incidenciaUsuarioCategoriaEdit.component';
import { RubroContableListaComponent } from '../../../../src/app/pages/rubro-contable/rubroContableLista.component';
import { RubroContableEditComponent } from '../../../../src/app/pages/rubro-contable/rubroContableEdit.component';
import { ComunidadTipoContratoListaComponent } from '../../../../src/app/pages/comunidad-tipo-contrato/comunidadTipoContratoLista.component'
import { ComunidadTipoContratoEditComponent } from '../../../../src/app/pages/comunidad-tipo-contrato/comunidadTipoContratoEdit.component'
import { PedidoListaComponent } from '../../../../src/app/pages/pedido/pedidoLista.component';
import { PedidoEditComponent } from '../../../../src/app/pages/pedido/pedidoEdit.component';
import { GremioListaComponent } from '../../pages/gremio/gremioLista.component';
import { GremioEditComponent } from '../../pages/gremio/gremioEdit.component';
import { EstadoCivilListaComponent } from '../../pages/estado-civil/estadoCivilLista.component';
import { EstadoCivilEditComponent } from '../../pages/estado-civil/estadoCivilEdit.component';
import { MotivoInasistenciaEditComponent } from '../../../../src/app/pages/motivoInasistencia/motivoInasistenciaEdit.component';
import { MotivoInasistenciaListaComponent } from '../../../../src/app/pages/motivoInasistencia/motivoInasistenciaLista.component';
import { EmpleadoEditComponent } from './../../pages/empleado/empleado-edit.component';
import { EmpleadoListComponent } from '../../pages/empleado/empleado-list.component';
import { UnidadMedidaEditComponent } from './../../pages/unidad-medida-materiales/unidad-medida-edit.component';
import { UnidadMedidaMaterialesListComponent } from './../../pages/unidad-medida-materiales/unidad-medida-materiales-list.component';
import { TipoMaterialListComponent } from '../../pages/tipo-materiales/tipo-material-list.component';
import { TipoMaterialEditComponent } from '../../pages/tipo-materiales/tipo-material-edit.component';
import { MaterialesEditComponent } from './../../pages/materiales/materiales-edit.component';
import { MaterialesListComponent } from './../../pages/materiales/materiales-list.component';
import { FormaDePagoListaComponent } from '../../../../src/app/pages/formas-de-pago/forma-de-pago-lista.component';
import { FormaDePagoEditComponent } from '../../../../src/app/pages/formas-de-pago/forma-de-pago-edit.component';
import { ProveedoresListaComponent } from '../../../../src/app/pages/proveedor/proveedores-lista.component';
import { ProveedoresEditComponent } from '../../../../src/app/pages/proveedor/proveedores-edit.component';
import { BancoListComponent } from '../../../../src/app/pages/bancos/banco-list.component';
import { BancoEditComponent } from '../../../../src/app/pages/bancos/banco-edit.component';
import { ComprasComponent } from '../../../../src/app/pages/pedido/compras/compras.component';
import { RecepcionPedidoComponent } from '../../../../src/app/pages/pedido/recepcion-pedido/recepcion-pedido.component';
import { ActividadPrincipalEditComponent } from '../../../../src/app/pages/actividad-principal/actividad-principal-edit.component';
import { ActividadPrincipalComponent } from './../../pages/actividad-principal/actividad-principal.component';
import { AlicuotaIvaEditComponent } from '../../pages/alicuota-iva/alicuota-iva-edit.component';
import { AlicuotaIvaListComponent } from '../../pages/alicuota-iva/alicuota-iva-list.component';
import { MedioPagoEditComponent } from '../../pages/medio-pago/medio-pago-edit.component';
import { MedioPagoListComponent } from '../../pages/medio-pago/medio-pago-list.component';
import { TipoMovimientoEditComponent } from '../../pages/tipo-movimiento/tipo-movimiento-edit.component';
import { TipoMovimientoListComponent } from '../../pages/tipo-movimiento/tipo-movimiento-list.component';
import { MovimientoEditComponent } from '../../pages/movimientos/movimientoEdit.component';
import { MovimientoPagoMasivoComponent } from '../../pages/movimientos/movimientoPagoMasivo.component';
import { MovimientoFinanciacionComponent } from '../../pages/movimientos/movimientoFinanciacion.component';
import { MovimientoRecurrenteComponent } from '../../pages/movimientos/movimientoRecurrente.component';
import { MovimientoDesdeDocumentoComponent } from '../../pages/movimientos/movimientoDesdeDocumento.component';
import { MovimientoViewComponent } from '../../pages/movimientos/movimientoView.component';
import { MovimientoListComponent } from '../../pages/movimientos/movimientoLista.component';
import { MiMovimientoViewComponent } from '../../pages/movimientos/miMovimientoView.component';
import { MiMovimientoListComponent } from '../../pages/movimientos/miMovimientoLista.component';
import { CuentaEditComponent } from '../../pages/cuenta/cuentaEdit.component';
import { CuentaListComponent } from '../../pages/cuenta/cuentaList.component';
import { ConversionMonedaListComponent } from '../../../../src/app/pages/moneda/conversionList.component';
import { ConversionMonedaEditComponent } from '../../../../src/app/pages/moneda/conversionEdit.component';

import { JobListaComponent } from '../../../../src/app/pages/jobs/jobs-lista.component';
import { JobsMovimientoSegundoVencimientoComponent } from '../../../../src/app/pages/jobs/components/jobs-movimiento-segundo-vencimiento/jobsMovimientoSegundoVencimiento.component';

import { ReporteAsistenciasComponent } from '../../pages/reportes/reporte-asistencias/reporteAsistencias.component'
import { ReporteEntregasComponent } from '../../../../src/app/pages/reportes/reporte-entregas/reporte-entregas.component';
import { ReporteConsolidadoCajaComponent } from '../../pages/reportes/reporte-consolidado-caja/reporte-consolidado-caja.component';
import { ReportePedidoMaterialComponent } from '../../../../src/app/pages/reportes/reporte-pedido-material/reporte-pedido-material.component';
import { ReporteCuentasDeudorasComponent } from '../../../../src/app/pages/reportes/reporte-cuentas-deudoras/reporte-cuentas-deudoras.component';

import { DashboardComponent } from '../../../../src/app/pages/dashboard/dashboard.component';
import { PedidosEstadosComponent } from './../../pages/dashboard/dashboard-estado-pedidos/pedidos-estados.component';
import { VencimientoPedidosComponent } from './../../pages/dashboard/dashboard-vencimiento-pedidos/vencimientoPedidos.component';
import { VencimientoPedidoTipoMaterialComponent } from './../../pages/dashboard/dashboard-vencimiento-pedidos-tipo-material/vencimientoPedidoTipoMaterial.component';
import { VencimientoSegurosComponent } from './../../pages/dashboard/dashboard-vencimiento-seguros/vencimientoSeguros.component';
import { CardComunidadesComponent } from './../../pages/dashboard/dashboard-comunidades/card-comunidades.component';
import { VencimientoIncidenciasComponent } from './../../pages/dashboard/dashboard-vencimiento-incidencias/vencimientoIncidencias.component';
import { GastoServiciosComponent } from './../../pages/dashboard/dashboard-gasto-servicios/gasto-servicios.component';
import { GastoTipoGastosComponent } from './../../pages/dashboard/dashboard-gasto-tipo-gasto/gasto-tipo-gastos.component';
import { MovimientoTipoMovimientosComponent } from '../../pages/dashboard/dashboard-movimiento-tipo-movimiento/movimiento-tipo-movimientos.component';
import { GastoRankingServiciosComponent } from './../../pages/dashboard/dasboard-gasto-ranking-servicios/gastoRankingServicios.component';
import { GastoRankingTiposGastoComponent } from './../../pages/dashboard/dasboard-gasto-ranking-tipos-gasto/gastoRankingTiposGasto.component';
import { ExpensasUfComponent } from './../../pages/dashboard/dashboard-expensas-uf/expensasUf.component';
import { MisPagosComponent } from './../../pages/dashboard/dashboard-mis-pagos/misPagos.component';
import { MisGastosComponent } from './../../pages/dashboard/dashboard-mis-gastos/misGastos.component';
import { PublicacionesComponent } from './../../pages/dashboard/dashboard-publicaciones/publicaciones.component';
import { MiResumenSaldoComponent } from './../../pages/dashboard/dashboard-mi-resumen-saldo/miResumenSaldo.component';

import { DialogModificarFechaComponent } from '../../../../src/app/pages/asistencias/component/dialogModificarFecha.component';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogCambioPasswordComponent } from '../../../../src/app/shared/components/modals/dialogCambioPassword.component';
import { DialogMensajePopUpComponent } from '../../../../src/app/shared/components/modals/dialogMensajePopUp.component';
import { DialogTextoLibreComponent } from '../../../../src/app/shared/components/modals/dialogTextoLibre.component';
import { DialogOlvidoClaveComponent } from '../../../../src/app/auth/components/dialogOlvidoClave.component';
import { DialogOlvidoUsuarioComponent } from '../../../../src/app/auth/components/dialogOlvidoUsuario.component';
import { DialogRegistroUsuarioComponent } from '../../../../src/app/auth/components/dialogRegistroUsuario.component';
import { DialogSetearClaveComponent } from '../../../../src/app/auth/components/dialogSetearClave.component';
import { DialogUnidadFuncionalPersonaGestionComponent } from '../../pages/unidad-funcional/components/dialogUnidadFuncionalPersonaGestion.component';
import { DialogUnidadFuncionalSearchComponent } from '../../pages/unidad-funcional/components/dialogUnidadFuncionalSearch.component';
import { DialogUsuarioSearchComponent } from '../../pages/usuarios/components/dialogUsuarioSearch.component';
import { DialogPersonaSearchComponent } from '../../pages/usuarios/components/dialogPersonaSearch.component';
import { DialogExpensaLiquidacionSimulacionComponent } from '../../pages/expensa/components/dialogExpensaLiquidacionSimulacion.component';
import { DialogMotivoInasistenciaComponent } from '../../pages/asistencias/component/dialogMotivoInasistencia.component';
import { DialogModificarPedidoItemComponent } from '../../pages/pedido/components/dialogModificarPedidoItem.component';
import { DialogAgregarPresupuestoComponent } from '../../../../src/app/pages/pedido/components/dialog-agregar-presupuesto.component';
import { DialogAgregarComparativaComponent } from '../../../../src/app/pages/pedido/components/dialogAgregarComparativa.component';
import { DialogVerRemitoComponent } from '../../../../src/app/pages/pedido/components/dialogVerRemito.component';
import { DialogAgregarMaterialComponent } from './../../pages/pedido/components/dialog-agregar-material.component';
import { DialogCuentaSearchComponent } from '../../../../src/app/pages/cuenta/components/dialogCuentaSearch.component';
import { DialogCargaMovimientoComponent } from '../../../../src/app/pages/movimientos/components/dialogCargaMovimiento.component';
import { DialogUnidadFuncionalGestionComponent } from '../../../../src/app/pages/unidad-funcional/components/dialogUnidadFuncionalGestion.component';
import { DialogPersonaGestionComponent } from '../../../../src/app/pages/usuarios/components/dialogPersonaGestion.component';
import { DialogDetalleMovimientosConsolidadoCajaComponent } from '../../../../src/app/pages/reportes/reporte-consolidado-caja/components/dialogDetalleMovimientosConsolidadoCaja.component';
import { DialogDetalleMovimientosCuentasDeudorasComponent } from '../../../../src/app/pages/reportes/reporte-cuentas-deudoras/components/dialogDetalleMovimientosCuentasDeudoras.component';
import { ResumenCajaComponent } from '../../pages/dashboard/dashboard-resumen-caja/resumenCaja.component';
import { DialogFechaMasivaMaterialComponent } from '../../../../src/app/pages/pedido/components/dialog-fecha-masiva-material.component';
import { DialogUnidadFuncionalImportComponent } from '../../../../src/app/pages/unidad-funcional/components/dialog-unidad-funcional-import.component';
import { DialogUnidadFuncionalPersonaImportComponent } from '../../../../src/app/pages/unidad-funcional/components/dialog-unidad-funcional-persona-import.component';
import { DialogExpensaGastosPeriodoComponent } from '../../../../src/app/pages/expensa/components/dialogExpensaGastosPeriodo.component';

@NgModule({
  declarations: [
    DefaultComponent,
    MenuItemComponent,
    MenuLinkItemComponent,
    SubmenuItemComponent,
    AsistenciasListaComponent,
    MotivoInasistenciaListaComponent,
    MotivoInasistenciaEditComponent,
    HomeComponent,
    DashboardComponent,
    UsuarioListaComponent,
    UsuarioEditComponent,
    UsuarioSelfEditComponent,
    RolListaComponent,
    RolEditComponent,
    EstadoListaComponent,
    EstadoEditComponent,
    ParametroSistemaListaComponent,
    ParametroSistemaEditComponent,
    MensajeUsuarioListaComponent,
    MensajeUsuarioEditComponent,
    MensajeUsuarioViewComponent,
    MenuListaComponent,
    MenuEditComponent,
    MensajeUsuarioTipoEditComponent,
    MensajeUsuarioTipoListaComponent,
    MensajeUsuarioOpcionEnvioEditComponent,
    MensajeUsuarioOpcionEnvioListaComponent,
    MailConfiguracionEditComponent,
    MailConfiguracionListaComponent,
    TenantEditComponent,
    TenantListaComponent,
    RolTipoEditComponent,
    RolTipoListaComponent,
    FaqListaComponent,
    FaqEditComponent,
    FaqViewComponent,
    PersonaListaComponent,
    PersonaEditComponent,
    EmpleadoListComponent,
    EmpleadoEditComponent,
    FormaDePagoListaComponent,
    FormaDePagoEditComponent,
    ProveedoresListaComponent,
    ProveedoresEditComponent,
    BancoListComponent,
    BancoEditComponent,
    ComprasComponent,
    CategoriaSuterhListaComponent,
    CategoriaSuterhEditComponent,
    ResumenCajaComponent,
    MonedaListaComponent,
    MonedaEditComponent,
    PaisListaComponent,
    PaisEditComponent,
    TipoDocumentoListaComponent,
    TipoDocumentoEditComponent,
    TipoGastoListaComponent,
    TipoGastoEditComponent,
    TipoResponsableIvaListaComponent,
    TipoResponsableIvaEditComponent,
    TipoUnidadListaComponent,
    TipoUnidadEditComponent,
    TipoComunidadListaComponent,
    TipoComunidadEditComponent,
    ProvinciaListaComponent,
    ProvinciaEditComponent,
    UnidadFuncionalListaComponent,
    UnidadFuncionalEditComponent,
    UnidadFuncionalPersonaComponent,
    ComunidadListaComponent,
    ComunidadEditComponent,
    ComunidadPublicacionListaComponent,
    ComunidadPublicacionEditComponent,
    ComunidadPublicacionViewComponent,
    UfTipoRelacionListaComponent,
    UfTipoRelacionEditComponent,
    ConsorcioListaComponent,
    ConsorcioEditComponent,
    CategoriaGastoListaComponent,
    CategoriaGastoEditComponent,
    ServicioGastoListaComponent,
    ServicioGastoEditComponent,
    ExpensaConfiguracionComponent,
    ExpensaLiquidacionComponent,
    ExpensaListaComponent,
    ExpensaEditComponent,
    GastoListaComponent,
    MiGastoListaComponent,
    GastoEditComponent,
    GastoRecurrenteComponent,
    GastoDesdeDocumentoComponent,
    ServicioGrupoListaComponent,
    ServicioGrupoEditComponent,
    ContratoListaComponent,
    ContratoEditComponent,
    IncidenciaUsuarioBackofficeListaComponent,
    IncidenciaUsuarioBackofficeEditComponent,
    IncidenciaUsuarioListaComponent,
    IncidenciaUsuarioEditComponent,
    IncidenciaUsuarioCategoriaListaComponent,
    IncidenciaUsuarioCategoriaEditComponent,
    MaterialesListComponent,
    MaterialesEditComponent,
    TipoMaterialEditComponent,
    TipoMaterialListComponent,
    UnidadMedidaMaterialesListComponent,
    UnidadMedidaEditComponent,
    GremioListaComponent,
    GremioEditComponent,
    EstadoCivilListaComponent,
    EstadoCivilEditComponent,
    RubroContableListaComponent,
    RubroContableEditComponent,
    ComunidadTipoContratoListaComponent,
    ComunidadTipoContratoEditComponent,
    VencimientoSegurosComponent,
    VencimientoPedidosComponent,
    VencimientoPedidoTipoMaterialComponent,
    VencimientoIncidenciasComponent,
    GastoServiciosComponent,
    GastoTipoGastosComponent,
    MovimientoTipoMovimientosComponent,
    PedidoListaComponent,
    PedidoEditComponent,
    RecepcionPedidoComponent,
    PedidosEstadosComponent,
    ActividadPrincipalComponent,
    ActividadPrincipalEditComponent,
    AlicuotaIvaListComponent,
    AlicuotaIvaEditComponent,
    MedioPagoListComponent,
    MedioPagoEditComponent,
    TipoMovimientoListComponent,
    TipoMovimientoEditComponent,
    MovimientoEditComponent,
    MovimientoPagoMasivoComponent,
    MovimientoFinanciacionComponent,
    MovimientoRecurrenteComponent,
    MovimientoDesdeDocumentoComponent,
    MovimientoViewComponent,
    MovimientoListComponent,
    MiMovimientoViewComponent,
    MiMovimientoListComponent,
    CuentaEditComponent,
    CuentaListComponent,
    ConversionMonedaListComponent,
    ConversionMonedaEditComponent,

    JobListaComponent,
    JobsMovimientoSegundoVencimientoComponent,
    
    ReporteAsistenciasComponent,
    ReporteEntregasComponent,
    ReporteConsolidadoCajaComponent,
    ReportePedidoMaterialComponent,
    ReporteCuentasDeudorasComponent,
    
    CardComunidadesComponent,
    GastoRankingServiciosComponent,
    GastoRankingTiposGastoComponent,
    ExpensasUfComponent,
    MisPagosComponent,
    MisGastosComponent,
    PublicacionesComponent,
    MiResumenSaldoComponent,

    DialogModificarFechaComponent,
    DialogConfirmComponent,
    DialogCambioPasswordComponent,
    DialogMensajePopUpComponent,
    DialogTextoLibreComponent,
    DialogOlvidoClaveComponent,
    DialogOlvidoUsuarioComponent,
    DialogRegistroUsuarioComponent,
    DialogSetearClaveComponent,
    DialogExpensaLiquidacionSimulacionComponent,
    DialogUnidadFuncionalPersonaGestionComponent,
    DialogUnidadFuncionalSearchComponent,
    DialogPersonaSearchComponent,
    DialogUsuarioSearchComponent,
    DialogMotivoInasistenciaComponent,
    DialogModificarPedidoItemComponent,
    DialogAgregarMaterialComponent,
    DialogAgregarPresupuestoComponent,
    DialogAgregarComparativaComponent,
    DialogCuentaSearchComponent,
    DialogVerRemitoComponent,
    DialogDetalleMovimientosConsolidadoCajaComponent,
    DialogDetalleMovimientosCuentasDeudorasComponent,
    DialogUnidadFuncionalGestionComponent,
    DialogPersonaGestionComponent,
    DialogCargaMovimientoComponent,
    DialogFechaMasivaMaterialComponent,
    DialogExpensaGastosPeriodoComponent,
    DialogUnidadFuncionalImportComponent,
    DialogUnidadFuncionalPersonaImportComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    FlexLayoutModule,
    MatSidenavModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatDividerModule,
    MatInputModule,
    MatIconModule,
    MatGridListModule,
    ButtonModule,
    GridModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    UploaderModule,
    TabModule,
    DialogModule,
    MatTabsModule,
    MatStepperModule,
    AutoCompleteModule,
    ComboBoxModule,
    MatListModule,
    MatCheckboxModule,
    CircularGaugeModule,
    MatExpansionModule,
    MatSliderModule,
    MatFormFieldModule,
    RichTextEditorModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    MatProgressSpinnerModule,
    TreeViewModule,
    MatAutocompleteModule,
    AccumulationChartModule,
    MatChipsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBBmVRtHAjSVdUS4IaZHkbvKUMYI6Xmhuw'
    })
  ],
  providers:[
    DatePipe,
    PageService,
    EditService,
    SortService,
    ResizeService,
    FilterService,
    AggregateService,
    GroupService,
    AnnotationsService,
    ExcelExportService,
    ToolbarService,
    DetailRowService,
    AccumulationDataLabelService,
    AccumulationLegendService,
    PieSeriesService,
    AccumulationTooltipService,
    AccumulationAnnotationService
  ]
})
export class DefaultModule { }
